import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCloud, FiCode, FiDatabase, FiShield, FiTrendingUp, FiSettings } = FiIcons;

const Services = () => {
  const services = [
    {
      icon: FiCloud,
      title: "Cloud Migration",
      description: "Seamlessly migrate your infrastructure to cloud-native platforms with zero downtime and enhanced performance.",
      gradient: "from-blue-500 to-cyan-500"
    },
    {
      icon: FiCode,
      title: "Digital Development",
      description: "Build scalable applications using cutting-edge open-source technologies and modern development practices.",
      gradient: "from-indigo-500 to-purple-500"
    },
    {
      icon: FiDatabase,
      title: "Data Architecture",
      description: "Design robust data pipelines and analytics systems that turn your data into actionable business insights.",
      gradient: "from-purple-500 to-pink-500"
    },
    {
      icon: FiShield,
      title: "Security Integration",
      description: "Implement enterprise-grade security measures across all touchpoints of your digital infrastructure.",
      gradient: "from-green-500 to-teal-500"
    },
    {
      icon: FiTrendingUp,
      title: "Process Automation",
      description: "Automate repetitive tasks and workflows to increase efficiency and reduce operational overhead.",
      gradient: "from-orange-500 to-red-500"
    },
    {
      icon: FiSettings,
      title: "System Integration",
      description: "Connect disparate systems and create unified workflows that enhance productivity and collaboration.",
      gradient: "from-teal-500 to-blue-500"
    }
  ];

  return (
    <section id="services" className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Comprehensive
            <span className="bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">
              {" "}Digital Solutions
            </span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            From cloud migration to process automation, we provide end-to-end digital transformation 
            services that revolutionize how your business operates.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
              className="group relative"
            >
              <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-8 border border-white/10 hover:border-white/20 transition-all duration-300 h-full">
                <div className={`w-16 h-16 bg-gradient-to-r ${service.gradient} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <SafeIcon icon={service.icon} className="text-2xl text-white" />
                </div>
                
                <h3 className="text-2xl font-bold text-white mb-4">{service.title}</h3>
                <p className="text-gray-300 leading-relaxed">{service.description}</p>
                
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;